import { TextArea, Validator } from 'devextreme-react';
import { RequiredRule } from 'devextreme-react/cjs/validator';
import { t } from 'i18next';

interface TextInputProps {
    className?: string
    label?: string;
    required?: boolean;
    disabled?: boolean;
    value: string;
    onChange: (value: string) => void;
}

export default function TextAreaInput(props: TextInputProps) {
    return (
        <TextArea
            className={props.className}
            label={props.label}
            disabled={props.disabled}
            stylingMode="outlined"
            autoResizeEnabled={true}
            value={props.value}
            onValueChanged={(e) => props.onChange(e.value)}>
            { props.required && <Validator>
                <RequiredRule message={t("This field is required")} />
            </Validator> }

        </TextArea>
    )
}
